var option_default = {
  "option": "OKZ-4",
  "user_choice": "khVBr",
  "check": "zbqjL",
  "image": "LWy0y",
  "input": "pVaQk",
  "title": "bLkm3",
  "centered": "w10mV",
  "with_result": "H5wQh",
  "list": "ikPBL",
  "with_image": "FSyOx",
  "progress": "doT-i",
  "progress_value": "ebvRD",
  "label": "Rb2vu",
  "cta": "IkfZm",
  "adornment_icon": "_6xQBr",
  "remove": "NT-Om",
  "removeButton": "_7SAvO",
  "removeButtonIcon": "n85l7",
  "overlay": "fhPTL",
  "shown": "_3EdF-",
  "dark": "wnGz6",
  "spinner": "xUfwG",
  "spin": "q37-K"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
